import {Label, Spinner, TextInput} from "flowbite-react";
import CustomButton from "../../../components/common/CustomButton";
import {Drawer} from "../../../components/Modals";
import React, {useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {notify} from 'react-notify-toast';
import {useProjectService} from "../../../services";

interface ShareModalProps {
  showShareModal: boolean;
  onCloseShareModal: () => void;
}

const ShareModal: React.FC<ShareModalProps> = ({ showShareModal, onCloseShareModal }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [revokeSwitch, setRevokeSwitch] = useState(false);

  const {
    updateProject,
  } = useProjectService();

  const { share_link = false } = useSelector((state: any) => state.roadmap);

  const {
    projectShareData,
    projectShareLoading,
  } = useSelector((state: any) => state.projects);

  useEffect(() => {
    setRevokeSwitch(share_link);
  }, [share_link]);

  const {
    currentEntityId,
  } = useSelector((state: any) => state.timeline);

  const handleRevokeSwitch = async (e: any) => {
    const check = e.target.checked;
    if (check) {
      setRevokeSwitch(true);
      if (currentEntityId) {
        await updateProject(currentEntityId, { share_link: true, isFetchAllProjects: false });
      }
    } else {
      setRevokeSwitch(false);
      if (currentEntityId) {
        await updateProject(currentEntityId, { share_link: false, isFetchAllProjects: false });
      }
    }
  };

  const copyToClipboard = async (url: string) => {
    try {
      if (revokeSwitch) {
        if (navigator.clipboard) {
          try {
            await navigator.clipboard.writeText(url);
            notify.show('Copied to clipboard successfully!', "success", 2000);
          } catch (err) {
            notify.show('Failed to copy: ', "error", 2000);
          }
        } else {
          // Fallback for browsers without clipboard support
          let textArea = document.createElement('textarea');
          textArea.value = url;
          document.body.appendChild(textArea);
          textArea.select();
          try {
            document.execCommand('copy');
            notify.show('Copied to clipboard successfully!', "success", 2000);
          } catch (err) {
            notify.show('Failed to copy using fallback: ', "error", 2000);
          }
          document.body.removeChild(textArea);
        }
      }
    } catch (error) {
      notify.show("URL copied to clipboard is not available.", "error", 2000);
    }
  };

  return (
    <Drawer
      isOpen={showShareModal}
      onClose={onCloseShareModal}
      position="right"
    >
      <div className="relative h-[calc(100%-55px)] overflow-auto flex flex-col">
        <div className={`flex flex-row border-b border-gray-200 !p-6 dark:border-gray-700 ${'bg-secondary-light dark:bg-primary-dark'} text-white sticky top-0 z-40`}>
          <div className="flex w-full h-12 mr-10 items-center">
            <div className={`text-center dark:text-white text-white text-sm font-normal font-['Inter'] leading-3`}>Share</div>
            <button
              type="button"
              className="ml-auto absolute right-[10px] top-0 dark:text-white text-white w-6 h-6 rounded-full bg-black text-sm"
              onClick={onCloseShareModal}
            >
              X
            </button>
          </div>
        </div>

        <div className='p-5'>
          {projectShareLoading ? (
            <>
              {projectShareLoading && (
                <div className="text-center w-full h-full bottom-0">
                  <Spinner aria-label="Center-aligned spinner example" />
                </div>
              )}
            </>
          ) : (
            <div className="flex flex-col gap-5 dark:text-white text-gray-700">
              <div className="flex flex-col w-full gap-5">
                <div className="flex items-center gap-2">
                  <div className="button r switchToggle">
                    <input
                      type="checkbox"
                      checked={revokeSwitch}
                      onChange={handleRevokeSwitch}
                      className="checkbox" />
                    <div className="knobs"></div>
                    <div className="layer"></div>
                  </div>
                  <Label htmlFor="revokeSwitch" className="flex">
                    {`Shareable link`}
                  </Label>
                </div>
                {revokeSwitch && (
                  <>
                    <div>
                      <Label htmlFor="liveUrl">Live URL</Label>
                      <div className="mt-1 flex gap-5">
                        <TextInput
                          type="text"
                          className="w-full !rounded-none bg-tertiary-light dark:bg-secondary-dark text-gray-900 dark:text-white border-gray-300 dark:border-gray-600 focus:ring-primary-light focus:border-primary-light dark:focus:ring-primary-dark dark:focus:border-primary-dark"
                          id="liveUrl"
                          value={`${window.location.host}/projects/${projectShareData?.live}/sharelink`}
                          readOnly
                          ref={inputRef}
                          onFocus={() => inputRef?.current?.select()}
                        />
                        <CustomButton
                          onClick={() => copyToClipboard(`${window.location.host}/projects/${projectShareData?.live}/sharelink`)}
                          className="bg-primary-light dark:bg-primary-dark hover:bg-primary-dark text-white"
                          size="sm"
                        >
                          Copy Link
                        </CustomButton>
                      </div>
                    </div>
                    <div>
                      <Label htmlFor="SimulationUrl">Simulation URL</Label>
                      <div className="mt-1 flex gap-5">
                        <TextInput
                          type="text"
                          className="w-full !rounded-none bg-tertiary-light dark:bg-secondary-dark text-gray-900 dark:text-white border-gray-300 dark:border-gray-600 focus:ring-primary-light focus:border-primary-light dark:focus:ring-primary-dark dark:focus:border-primary-dark"
                          id="SimulationUrl"
                          value={`${window.location.host}/projects/${projectShareData?.simulation}/sharelink`}
                          readOnly
                          ref={inputRef}
                          onFocus={() => inputRef?.current?.select()}
                        />
                        <CustomButton
                          onClick={() => copyToClipboard(`${window.location.host}/projects/${projectShareData?.simulation}/sharelink`)}
                          className="bg-primary-light dark:bg-primary-dark hover:bg-primary-dark text-white"
                          size="sm"
                        >
                          Copy Link
                        </CustomButton>
                      </div>
                    </div>
                  </>
                  )}
              </div>
            </div>
          )}
        </div>
      </div>
    </Drawer>
  )
}

export default ShareModal;